import React, { Component } from "react";
import Select from "react-select";
import COLORS from "scss/colors.module.scss";
import chroma from "chroma-js";
import { observer, inject } from "mobx-react";
import ApiClient from "utils/ApiClient";
import { formatDate, formatTime } from "../../helpers/dateFormatter";

class LookupColumnEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [
        {
          value: "Loading ...",
          label: "Loading ...",
          color: COLORS.TEXT_COLOR,
          background: COLORS.PRIMARY_COLOR,
        },
      ],
      selectedOption: props.value,
      top: false,
      bottom: false,
      isWaitingForDependantColumns: false,
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.columnOptions = this.props.colDef?.cellRendererParams?.columnOptions;
    this.isSubsheet =
      this.props.colDef?.cellRendererParams?.isSubsheet ?? false;
    this.gridStore = this.props.colDef?.cellRendererParams?.store ?? {};
    // console.log(this.gridStore);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  focusNextCell = () => {
    this.props.api.setFocusedCell(
      // this.props.rowIndex + 1,
      this.props.rowIndex,
      this.props.column.colId
    );
  };

  handleChange = (selectedOption, shouldStopEditing = false) => {
    this.props.onChange({
      reference_column_id: selectedOption.reference_column_id,
      value: selectedOption.value,
    });
    this.setState({ selectedOption: selectedOption.value }, () => {
      if (shouldStopEditing) {
        this.props.api.stopEditing();
        this.focusNextCell();
      }
    });
  };

  componentDidMount() {
    this.refs.container.addEventListener("keydown", this.arrowKeyNavigation);
    this.focus();
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener("keydown", this.arrowKeyNavigation);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  arrowKeyNavigation = (event) => {
    // console.log("lookup");
    if (
      [13].indexOf(event.keyCode) > -1 &&
      this.refs.selectRef.select.state.focusedOption
    ) {
      if (
        this.refs.selectRef.select.state.focusedOption.label !== "Loading ..."
      ) {
        this.handleChange(
          this.refs.selectRef.select.state.focusedOption,
          false
        );
      } else {
        event.stopPropagation();
      }
    }
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.props.api.stopEditing(false);
    }
  }

  focus = async () => {
    if (this.state.isWaitingForDependantColumns) {
      return;
    }

    this.setState({
      options: [
        {
          value: "Loading ...",
          label: "Loading ...",
          color: COLORS.TEXT_COLOR,
          background: COLORS.PRIMARY_COLOR,
        },
      ],
    });

    this.refs.selectRef.focus();
    document.addEventListener("mousedown", this.handleClickOutside);

    const options = [
      {
        reference_column_id: "",
        value: "",
        label: "",
        color: COLORS.TEXT_COLOR,
        background: "transparent",
      },
    ];
    const lookupData = await this.getLookupData();

    lookupData.map((option, index) => {

      let value = option["column_" + this.columnOptions.source_column_id];
      if (
        this.columnOptions.column_type == "percentage" &&
        String(value).length > 0 &&
        String(value).includes(".")
      ) {
        let decimals =
          String(value).includes(".") && String(value).split(".")[1].length >= 2
            ? String(value).split(".")[1].length
            : 2;
        value = (Number(value) * 100).toFixed(decimals - 2) + " %";
      }
      if (
        (this.columnOptions?.column_type == "date" ||
          this.columnOptions?.column_type == "datetime") &&
        String(value).length > 0
      ) {
        let sourceColumnTypeID =
          this.columnOptions?.column_type == "date" ? "4" : "16";
        let dateFormat = formatDate(
          value,
          "YYYY-MM-DD",
          this.columnOptions?.format
            ? this.columnOptions?.format
            : sourceColumnTypeID == "4"
            ? "M j, Y"
            : "M j, Y g:iA"
        );
        let timeFormat = formatTime(value, sourceColumnTypeID);
        value =
          sourceColumnTypeID == "4" ? dateFormat : dateFormat + " " + timeFormat;
      }
      let fileNames = "";
      if ( this.columnOptions.column_type === "file" ){
        const source_column_id = this.columnOptions.source_column_id;
        const imagesStringArray = option[`column_${source_column_id}`];
        const imagesArray = JSON.parse(imagesStringArray || "[]");
        fileNames = imagesArray.map(i=>i.name).join(" ");
      }
      options.push({
        reference_column_id: option["row_id"],
        value: option["column_" + this.columnOptions.source_column_id],
        label: this.columnOptions.column_type === "file"? fileNames : value,
        color: COLORS.TEXT_COLOR,
        background: COLORS.PRIMARY_COLOR,
      });
      return 0;
    });
    this.setState({ options: options }, () => {
      if (
        window.innerHeight - this.refs.container.getBoundingClientRect().top <
        this.refs.container.getBoundingClientRect().height + (this.props.colDef.store.isSubsheet ? 200 : 40)
      ) {
        this.setState({
          top: null,
          bottom: 1,
        });
      } else {
        this.setState({
          top: this.props.node.rowHeight,
          bottom: null,
        });
      }
    });
  };

  getLookupData = async () => {
    const cellRendererParams = this.props.colDef.cellRendererParams;
    const queryParamsIds = this.columnOptions.query_params;
    const queryParams = {};

    queryParamsIds.forEach((colId) => {
      queryParams[colId] = this.findQueryParams(colId);
    });

    const lookupDataResp = await ApiClient.List.getLookupColumnData({
      column_id: cellRendererParams.columnId,
      query_params: JSON.stringify(queryParams),
    });
    return lookupDataResp.data;
  };

  findQueryParams(colId) {
    const rowData = this.props.node.data;

    let val = rowData["column_" + colId];

    if (this.isSubsheet && !val) {
      return this.gridStore?.parentRow?.["column_" + colId] ?? "";
    }

    return val;
  }

  getValue() {
    return this.state.selectedOption;
  }

  isPopup() {
    return true;
  }

  static getDerivedStateFromProps(props, state) {
    const isWaitingForDependantColumns = shouldWaitForDependantColumns(props);
    // console.log(isWaitingForDependantColumns);
    if (state.isWaitingForDependantColumns !== isWaitingForDependantColumns) {
      return {
        ...state,
        isWaitingForDependantColumns: isWaitingForDependantColumns,
      };
    }

    return null;
  }

  selectStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: this.props.colDef.width,
      margin: 8,
    }),
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
    }),
    valueContainer: (provided) => ({
      ...provided,
      cursor: "text",
    }),
    option: (provided, { isFocused }) => {
      const color = chroma(COLORS.THEME_COLOR);
      return {
        ...provided,
        minHeight: 32,
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        backgroundColor: isFocused ? color.alpha(0.1).css() : null,
      };
    },
  };

  render() {
    let rootStyle = {
      background: "white",
      textAlign: "center",
      display: "inline-block",
      position: "absolute",
      top: this.state.top,
      bottom: this.state.bottom,
      boxShadow: "4px 4px 10px " + COLORS.BOX_SHADOW,
    };

    const { selectedOption } = this.state;
    const shouldShowSavingOptions = this.state.isWaitingForDependantColumns;
    let options = this.state.options;

    if (shouldShowSavingOptions) {
      options = [
        {
          value: "Loading ...",
          label: "Waiting for dependent columns to save...",
          color: COLORS.TEXT_COLOR,
          background: COLORS.PRIMARY_COLOR,
        },
      ];
    }

    return (
      <div ref={this.setWrapperRef}>
        <div ref="container" style={rootStyle}>
          <Select
            ref="selectRef"
            value={selectedOption}
            defaultInputValue={this.props.charPress ? this.props.charPress : ""}
            onChange={(selectedOption) => {
              if (selectedOption.value !== "Loading ...")
                this.handleChange(selectedOption, true);
            }}
            options={options}
            autoFocus={true}
            menuIsOpen={true}
            backspaceRemovesValue={false}
            components={{
              DropdownIndicator: null,
              IndicatorSeparator: null,
            }}
            formatOptionLabel={OptionFormatter}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            placeholder="Find an option.."
            styles={this.selectStyles}
            tabSelectsValue={false}
            maxMenuHeight="25vh"
          />
        </div>
      </div>
    );
  }
}

const OptionFormatter = ({ value, label, color, background }) => (
  <div style={{ display: "flex" }}>{label}</div>
);

const selectStyles = {
  control: (provided) => ({
    ...provided,
    minWidth: 180,
    margin: 8,
  }),
  menu: () => ({
    boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  }),
  valueContainer: (provided) => ({
    ...provided,
    cursor: "text",
  }),
  option: (provided, { isFocused }) => {
    const color = chroma(COLORS.THEME_COLOR);
    return {
      ...provided,
      minHeight: 32,
      display: "flex",
      alignItems: "center",
      backgroundColor: isFocused ? color.alpha(0.1).css() : null,
    };
  },
};

const shouldWaitForDependantColumns = (props) => {
  // const columnOptions = JSON.parse(props.colDef?.cellRendererParams?.columnOptions)[0]
  if (!props.node.data.row_id) {
    // for new rows
    return false;
  }
  return false;

  const columnOptions = props.colDef?.cellRendererParams?.columnOptions;
  const queryParams = [...columnOptions.query_params];
  const cellMetaData = props.cellMetaData[props.rowIndex];

  if (cellMetaData) {
    console.log(cellMetaData);
    for (let i = 0; i < queryParams.length; i++) {
      const colId = queryParams[i];
      console.log(cellMetaData["column_" + colId]?.isSaving);
      if (cellMetaData["column_" + colId]?.isSaving) {
        return true;
      }
    }
  }

  return false;
};

export default observer(LookupColumnEditor);
